var map = {
	"./quizEco2/quiz2/1.png": 118,
	"./quizEco2/quiz2/2.png": 119,
	"./quizEco2/quiz2/3.png": 120,
	"./quizEco2/quiz2/4.png": 121,
	"./quizEco2/quiz2/5.png": 122,
	"./quizEco2/quiz2/6.png": 123,
	"./quizEco2/quiz20/1.png": 124,
	"./quizEco2/quiz20/2.png": 125,
	"./quizEco2/quiz20/3.png": 126,
	"./quizEco2/quiz21/1.png": 127,
	"./quizEco2/quiz25/1.png": 128,
	"./quizEco2/quiz25/2.png": 129,
	"./quizEco2/quiz26/1.png": 130,
	"./quizEco2/quiz26/2.png": 131,
	"./quizEco2/quiz26/3.png": 132,
	"./quizEco2/quiz27/1.png": 133,
	"./quizEco2/quiz27/2.png": 134,
	"./quizEco2/quiz28/1.png": 135,
	"./quizEco2/quiz28/2.png": 136,
	"./quizEco2/quiz3/1.png": 137,
	"./quizEco2/quiz3/2.png": 138,
	"./quizEco2/quiz3/3.png": 139,
	"./quizEco2/quiz4/1.png": 140,
	"./quizEco2/quiz4/2.png": 141,
	"./quizEco2/quiz4/3.png": 142,
	"./quizEco3E/quiz1/1.png": 143,
	"./quizEco3E/quiz10/1.png": 144,
	"./quizEco3E/quiz12/1.png": 145,
	"./quizEco3E/quiz13/1.png": 146,
	"./quizEco3E/quiz14/1.png": 147,
	"./quizEco3E/quiz14/2.png": 148,
	"./quizEco3E/quiz15/1.png": 149,
	"./quizEco3E/quiz15/2.png": 150,
	"./quizEco3E/quiz16/1.png": 151,
	"./quizEco3E/quiz17/1.png": 152,
	"./quizEco3E/quiz17/2.png": 153,
	"./quizEco3E/quiz18/1.png": 154,
	"./quizEco3E/quiz18/2.png": 155,
	"./quizEco3E/quiz19/1.png": 156,
	"./quizEco3E/quiz19/2.png": 157,
	"./quizEco3E/quiz2/1.png": 158,
	"./quizEco3E/quiz2/2.png": 159,
	"./quizEco3E/quiz20/1.png": 160,
	"./quizEco3E/quiz21/1.png": 161,
	"./quizEco3E/quiz21/2.png": 162,
	"./quizEco3E/quiz22/1.png": 163,
	"./quizEco3E/quiz22/2.png": 164,
	"./quizEco3E/quiz23/1.png": 165,
	"./quizEco3E/quiz23/2.png": 166,
	"./quizEco3E/quiz23/3.png": 167,
	"./quizEco3E/quiz3/1.png": 168,
	"./quizEco3E/quiz3/2.png": 169,
	"./quizEco3E/quiz4/1.png": 170,
	"./quizEco3E/quiz4/2.png": 171,
	"./quizEco3E/quiz5/1.png": 172,
	"./quizEco3E/quiz5/2.png": 173,
	"./quizEco3E/quiz6/1.png": 174,
	"./quizEco3E/quiz7/1.png": 175,
	"./quizEco3E/quiz7/2.png": 176,
	"./quizEco3E/quiz8/1.png": 177,
	"./quizEco3E/quiz8/2.png": 178,
	"./quizEco3E/quiz9/1.png": 179,
	"./quizEco3E/quiz9/2.png": 180,
	"./quizEco4NE/quiz3/1.png": 181,
	"./quizEco4NE/quiz3/2.png": 182,
	"./quizEco4NE/quiz3/3.png": 183,
	"./quizEco4NE/quiz4/1.png": 184,
	"./quizEco4NE/quiz4/2.png": 185,
	"./quizEco4NE/quiz5/1.png": 186,
	"./quizEco4NE/quiz5/2.png": 187,
	"./quizEco4NE/quiz6/1.png": 188,
	"./quizEco4NE/quiz6/2.png": 189,
	"./quizEco4NE/quiz6/3.png": 190,
	"./quizEstadistica2/quiz1/1.png": 191,
	"./quizEstadistica2/quiz1/2.png": 192,
	"./quizEstadistica2/quiz1/3.png": 193,
	"./quizEstadistica2/quiz2/1.png": 194,
	"./quizEstadistica2/quiz2/2.png": 195,
	"./quizEstadistica2/quiz2/3.png": 196,
	"./quizEstadistica2/quiz3/1.png": 197,
	"./quizEstadistica2/quiz3/2.png": 198,
	"./quizEstadistica2/quiz3/3.png": 199,
	"./quizEstadistica2/quiz4/1.png": 200,
	"./quizEstadistica2/quiz4/2.png": 201,
	"./quizEstadistica2/quiz4/3.png": 202,
	"./quizEstadistica2/quiz5/1.png": 203,
	"./quizEstadistica2/quiz5/2.png": 204,
	"./quizEstadistica2/quiz5/3.png": 205,
	"./quizEstadistica2/quiz6/1.png": 206,
	"./quizEstadistica2/quiz6/2.png": 207,
	"./quizEstadistica2/quiz6/3.png": 208,
	"./quizInferencia/quiz1/1.png": 209,
	"./quizInferencia/quiz1/2.png": 210,
	"./quizInferencia/quiz1/3.png": 211,
	"./quizInferencia/quiz2/1.png": 212,
	"./quizInferencia/quiz2/2.png": 213,
	"./quizInferencia/quiz2/3.png": 214,
	"./quizInferencia/quiz3/1.png": 215,
	"./quizInferencia/quiz3/2.png": 216,
	"./quizInferencia/quiz3/3.png": 217,
	"./quizInferencia/quiz4/1.png": 218,
	"./quizInferencia/quiz4/2.png": 219,
	"./quizInferencia/quiz4/3.png": 220,
	"./quizInferencia/quiz5/1.png": 221,
	"./quizInferencia/quiz5/2.png": 222,
	"./quizInferencia/quiz5/3.png": 223,
	"./quizInferencia/quiz6/1.png": 224,
	"./quizInferencia/quiz6/2.png": 225,
	"./quizInferencia/quiz6/3.png": 226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 316;